
// components/MailSms/components/SendTab/MessageForm.js
import React from 'react';
import { FiSend, FiRefreshCw } from 'react-icons/fi';

const MessageForm = ({
  activeTab,
  smsSendType,
  emailForm,
  setEmailForm,
  smsForm,
  setSmsForm,
  emailTemplates,
  smsTemplates,
  smsSettings,
  selectedLessons,
  lessons,
  handleSendEmail,
  handleSendSms,
  loading,
  selectedStudents
}) => {
  const title = activeTab === 'email' ? 'Email İçeriği' : 
               smsSendType === 'student' ? 'SMS İçeriği' : 'Ders Bilgilendirme';

  return (
    <>
      <h3 className="text-lg font-semibold mb-4">{title}</h3>

      {smsSendType === 'lesson' ? (
        // Lesson SMS Preview
        <div>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-800 font-medium mb-2">SMS Önizleme:</p>
            <p className="text-xs text-blue-700 italic">
              "Merhaba, öğrenciniz [ÖĞRENCİ ADI] için planlanan [DERS ADI] dersi [TARİH] tarihinde, 
              [SÜRE] dakika sürdü ve [KONU] konusunu işlendi. Son Bakiyeniz: [BAKİYE] TL. 
              İletişim: {smsSettings.contact_phone || '[İLETİŞİM TELEFONU]'}"
            </p>
          </div>

          {selectedLessons.length > 0 && (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              <p className="text-sm font-medium text-gray-700 mb-2">Seçilen Dersler:</p>
              {selectedLessons.map(lessonId => {
                const lesson = lessons.find(l => l.id === lessonId);
                return lesson ? (
                  <div key={lesson.id} className="bg-white p-3 rounded border text-sm">
                    <p className="font-medium">{lesson.ogrenci_adi}</p>
                    <p className="text-gray-600">{lesson.ders_adi} - {lesson.ders_konusu}</p>
                    <p className="text-gray-500">{new Date(lesson.baslangic_tarihi).toLocaleDateString('tr-TR')}</p>
                  </div>
                ) : null;
              })}
            </div>
          )}
        </div>
      ) : (
        <>
          {/* Template Selection */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Şablon Seç (Opsiyonel)
            </label>
            <select
              value={activeTab === 'email' ? emailForm.template_id : smsForm.template_id}
              onChange={(e) => {
                const templateId = e.target.value;
                if (activeTab === 'email') {
                  setEmailForm({ ...emailForm, template_id: templateId });
                  const template = emailTemplates.find(t => String(t.id) === String(templateId));
                  if (template) {
                    setEmailForm({
                      ...emailForm,
                      template_id: templateId,
                      custom_subject: template.subject,
                      custom_body: template.body
                    });
                  }
                } else {
                  setSmsForm({ ...smsForm, template_id: templateId });
                  const template = smsTemplates.find(t => String(t.id) === String(templateId));
                  if (template) {
                    setSmsForm({
                      ...smsForm,
                      template_id: templateId,
                      custom_message: template.content
                    });
                  }
                }
              }}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              <option value="">Şablon seçin...</option>
              {(activeTab === 'email' ? emailTemplates : smsTemplates).map(template => (
                <option key={template.id} value={template.id}>{template.name}</option>
              ))}
            </select>
          </div>

          {activeTab === 'email' ? (
            <>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Konu
                </label>
                <input
                  type="text"
                  value={emailForm.custom_subject}
                  onChange={(e) => setEmailForm({ ...emailForm, custom_subject: e.target.value })}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="Email konusu..."
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  İçerik
                </label>
                <textarea
                  value={emailForm.custom_body}
                  onChange={(e) => setEmailForm({ ...emailForm, custom_body: e.target.value })}
                  rows={8}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="Email içeriği..."
                />
              </div>
            </>
          ) : (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mesaj
              </label>
              <textarea
                value={smsForm.custom_message}
                onChange={(e) => setSmsForm({ ...smsForm, custom_message: e.target.value })}
                rows={6}
                maxLength={1000}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="SMS mesajı..."
              />
              <p className="text-sm text-gray-500 mt-1">
                {smsForm.custom_message.length}/1000 karakter
              </p>
            </div>
          )}

          {/* Variables Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-800 font-medium mb-2">Kullanılabilir Değişkenler:</p>
            <p className="text-xs text-blue-700">
              {'{{name}}'} - Öğrenci adı<br/>
              {'{{parent_name}}'} - Veli adı<br/>
              {'{{city}}'} - Şehir<br/>
              {'{{class_type}}'} - Sınıf
            </p>
          </div>
        </>
      )}

      <button
        onClick={activeTab === 'email' ? handleSendEmail : handleSendSms}
        disabled={loading || (activeTab === 'email' || smsSendType === 'student' ? selectedStudents.length === 0 : selectedLessons.length === 0)}
        className="w-full bg-purple-600 text-white py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors disabled:bg-gray-400"
      >
        {loading ? (
          <>
            <FiRefreshCw className="inline mr-2 animate-spin" />
            Gönderiliyor...
          </>
        ) : (
          <>
            <FiSend className="inline mr-2" />
            {activeTab === 'email' ? 'Email Gönder' : 
             smsSendType === 'student' ? 'SMS Gönder' : 'Ders SMS\'i Gönder'}
          </>
        )}
      </button>
    </>
  );
};

export default MessageForm;
